import { render, staticRenderFns } from "./ButtonBox.vue?vue&type=template&id=8081db5e&scoped=true"
import script from "./ButtonBox.vue?vue&type=script&lang=js"
export * from "./ButtonBox.vue?vue&type=script&lang=js"
import style0 from "./ButtonBox.vue?vue&type=style&index=0&id=8081db5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8081db5e",
  null
  
)

export default component.exports